<!-- Audience Network banner -->
<div class="anp anb">
  <a class="anp-link anb-unit" [attr.href]="data.url || null" target="_blank" rel="noopener noreferrer">
    <img class="anb-logo" [src]="avatar" alt="" />
    <div class="anb-copy">
      <div class="anb-headline">{{ headline }}</div>
      <div class="anb-domain">{{ domain }}</div>
    </div>
    <span class="anb-cta">{{ cta }}</span>
  </a>

  <div class="anp-note">
    <p class="anp-note-lead">Ads on the Audience Network are shown in third-party mobile apps and mobile websites.</p>
    <p>Please note, this is only a preview. The ad may show up differently in other apps and websites.</p>
  </div>
</div>
